import { Component, Inject, OnInit } from '@angular/core';
import { IOS_TRACKS, WhitelabelIosDeploymentTracks } from '../../models/whitelabel-ios-config';
import { ANDROID_TRACKS, WhitelabelAndroidDeploymentTracks } from '../../models/whitelabel-android-config';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WhitelabelConfiguration } from '../../models/whitelabel-config';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { androidTrackFormDetails, handleTrackControls, iosTracksFormDetails, tracksValidator } from '../../helpers/tracks.helper';

@Component({
  standalone: false,
  selector: 'app-whitelabel-run',
  templateUrl: './whitelabel-run.component.html',
  styleUrls: ['./whitelabel-run.component.css']
})
export class WhitelabelRunComponent implements OnInit {

  public androidTracks = ANDROID_TRACKS;
  
  public iosTracks = IOS_TRACKS;

  public runAppForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { configuration: WhitelabelConfiguration }, private dialogRef: MatDialogRef<WhitelabelRunComponent>, private formBuilder: FormBuilder){
    this.runAppForm = this.formBuilder.group({
      executeIos: new FormControl(data.configuration.hasIos(), Validators.required),
      executeAndroid: new FormControl(data.configuration.hasAndroid(), Validators.required),
      versionCode: new FormControl(null, Validators.required),
      versionName: new FormControl(null, Validators.required),
      iosTrack: new FormControl(iosTracksFormDetails.initialTrack),
      androidTrack: new FormControl(androidTrackFormDetails.initialTrack),
      releaseNotes: new FormControl(null, Validators.required)
    }, {
      validators: tracksValidator
    })

    handleTrackControls(this.runAppForm);
    this.handleSavedValues(data.configuration);
  }

  ngOnInit(): void {}

  public close() {
    this.dialogRef.close(null);
  }

  public onSubmit() {
    if (!this.runAppForm.valid) {
      this.runAppForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      tracks: {
        ios: this.iosTrack || null,
        android: this.androidTrack || null
      },
      versions: {
        versionName: this.versionName,
        versionCode: this.versionCode
      },
      releaseNotes: this.releaseNotes
    })
  }

  private handleSavedValues(savedConfiguration: WhitelabelConfiguration) {
    if (!savedConfiguration.hasAndroid()) this.runAppForm.removeControl('androidTrack'); 
    if (!savedConfiguration.hasIos()) this.runAppForm.removeControl('iosTrack');

    if (savedConfiguration.versions) {
      this.runAppForm.controls['versionName'].setValue(savedConfiguration.versions.versionName);
      this.runAppForm.controls['versionCode'].setValue(Number(savedConfiguration.versions.versionCode) + 1);
    }
  }

  private get releaseNotes() {
    return this.runAppForm.controls['releaseNotes']?.value;
  }

  private get iosTrack() {
    return this.runAppForm.controls['iosTrack']?.value;
  }

  private get androidTrack() {
    return this.runAppForm.controls['androidTrack']?.value;
  }

  private get versionName() {
    return this.runAppForm.controls['versionName']?.value;
  }

  private get versionCode() {
    return this.runAppForm.controls['versionCode']?.value;
  }

}
